<template>
  <v-app id="inspire">
    <app-topbar
      v-on:drawerUpdate="updateDrawer"
    ></app-topbar>
    <app-sidebar
      :drawerUpdate="drawerUpdate"
    ></app-sidebar>
    <v-main>
      <router-view/>
    </v-main>
   
  </v-app>
</template>

<script>
  import Sidebar from './layout/Sidebar.vue'
  import Topbar from './layout/Topbar.vue'

  export default {
    components : {
      appSidebar : Sidebar,
      appTopbar : Topbar
    },
    data: () => ({  
      drawerUpdate : 0,
    }),
    created(){
    },
    methods: {
      updateDrawer(){
        this.drawerUpdate +=1
      }
    }
  }
</script>